module.exports = __webpack_public_path__ + "img/alentour11.82781091.jpg";